import { Text } from '@chakra-ui/react';

const Label = ({ formId, children, labelClassname }) => {
  return (
    <Text
      htmlFor={formId}
      textStyle={'md'}
      fontWeight={'semibold'}
      m={0}
      labelClassname={labelClassname || {}}
    >
      {children}
    </Text>
  );
};

export default Label;
